var map = {
	"./CuteAdventure.mp3": "4014",
	"./Icons_Globe.png": "9686",
	"./Icons_Language.png": "eeda",
	"./Icons_Math.png": "4349",
	"./Icons_Puzzle.png": "1ad9",
	"./games/arrow.svg": "2210",
	"./games/back-arrow.png": "f6f0",
	"./games/channels-link.svg": "a06d",
	"./games/mastered-game-icon.png": "5f67",
	"./games/play-button.png": "1294",
	"./games/play-icon.png": "b5ea",
	"./games/premium-game-icon.png": "e0f7",
	"./games/search-link.svg": "6bbd",
	"./games/view-switcher.svg": "a801",
	"./games/zoom.svg": "0baa",
	"./icon-globe-white.png": "195d",
	"./icon-language-white.png": "a4ea",
	"./icon-math-white.png": "56d3",
	"./icon_puzzle-white.png": "b1eb",
	"./img/avatarSelection/Avatar Frame.png": "97b6",
	"./img/avatarSelection/Avatar Pane Frame.png": "744f",
	"./img/avatarSelection/Avatar Selection Screen.jpg": "7f45",
	"./img/avatarSelection/Background.jpg": "28f3",
	"./img/avatarSelection/Filter Borders.png": "6f80",
	"./img/avatarSelection/Filter Button Normal.png": "4c29",
	"./img/avatarSelection/Filter Button Selected.png": "ecb7",
	"./img/avatarSelection/Text background.png": "5b9e",
	"./img/boy.png": "0c85",
	"./img/chicken.jpg": "2c776",
	"./img/gameBG.jpg": "f36a",
	"./img/genderSelection/Boy or Girl Page.jpg": "b770",
	"./img/genderSelection/BoyGirl Button.png": "a231",
	"./img/genderSelection/BoyGirlFrame.png": "9e13",
	"./img/genderSelection/BoyGirlFrame1.png": "8192",
	"./img/genderSelection/Character_Boy.png": "4540",
	"./img/genderSelection/Character_Boy1.png": "e51a",
	"./img/genderSelection/Character_Girl.png": "92c3",
	"./img/genderSelection/Character_Girl1.png": "1ba2",
	"./img/genderSelection/Text background.png": "b174",
	"./img/genderSelection/Text_Boy.png": "4cee",
	"./img/genderSelection/Text_Girl.png": "153e",
	"./img/genderSelection/background.jpg": "7a5d",
	"./img/genderSelection/separator bar.png": "f7b5",
	"./img/girl.png": "7b3a",
	"./img/nicknameSelection/Character Nickname Screen.jpg": "0b31",
	"./img/nicknameSelection/Name Frame.png": "c7ff",
	"./img/nicknameSelection/background.jpg": "dfcf",
	"./img/nicknameSelection/button.png": "3294",
	"./img/nicknameSelection/nameFrame.png": "db6a",
	"./img/nicknameSelection/nextArrow.png": "ad92",
	"./img/nicknameSelection/path12.png": "4a58",
	"./option-list-arr.svg": "f6ff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";